export const ensureAcceptedFilesNotEmpty = (callback) => (...args) => {
  const [acceptedFiles] = args;
  const [file] = acceptedFiles;

  return file
    ? callback(...args)
    : false;
};
